import {
	IModel,
	IVIPCapabilityEventBase,
	VIPCapabilityEventBase,
} from "@/loader";

/**
 * Capability Event Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.16.0
 * @since		1.0.0
 */
export interface IVIPCapabilityEvent extends IVIPCapabilityEventBase {
}

/**
 * Capability Event Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.16.0
 * @since		1.0.0
 */
export class VIPCapabilityEvent extends VIPCapabilityEventBase implements IVIPCapabilityEvent, IModel<IVIPCapabilityEvent> {
	constructor (data: IVIPCapabilityEvent = {}) {
		super(data);
	}

	public load(data: IVIPCapabilityEvent) {
		super.load(data);
	}

	public update(data: IVIPCapabilityEvent) {
		super.update(data);
	}
}
